var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconThumbsDownFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6673 2.5C17.1257 2.5 17.5177 2.66352 17.8441 2.98991C18.1705 3.3163 18.334 3.70833 18.334 4.16667V11.6667C18.334 12.125 18.1705 12.517 17.8441 12.8434C17.5177 13.1698 17.1257 13.3333 16.6673 13.3333H14.1673L9.16732 18.2918C8.959 18.5001 8.71226 18.6217 8.42757 18.6564C8.14294 18.6911 7.86863 18.639 7.60482 18.5002C7.34093 18.3613 7.14632 18.1667 7.02132 17.9167C6.89637 17.6667 6.86891 17.4098 6.93831 17.146L7.87581 13.3333H2.50065C2.05621 13.3333 1.66699 13.167 1.33366 12.8337C1.00033 12.5003 0.833984 12.1111 0.833984 11.6667V10C0.833984 9.90279 0.847717 9.7986 0.875488 9.6875C0.903266 9.57639 0.931532 9.47222 0.95931 9.375L3.45931 3.50016C3.58431 3.22238 3.79264 2.98579 4.08431 2.79134C4.37586 2.59706 4.68134 2.5 5.00065 2.5H16.6673Z",
    fill: "#0D61BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThumbsDownFilled);
export default __webpack_public_path__ + "static/media/icon-thumbs-down-filled.d23b8612fe18a18ebc8d2806bcb4fad9.svg";
export { ForwardRef as ReactComponent };